import { useTranslation } from "react-i18next";

import { UserPlusIcon } from "@lucide/icons";

import { Button } from "simplydo/react/ui/button";
import { Icon } from "simplydo/react/ui/icon";
import {
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from "simplydo/react/ui/modal";

type AssignIdeaProps = {
  isOpen: boolean;
  onClose: () => void;
  assignIdea: () => void;
  loading: boolean;
};

const AssignIdea = ({
  isOpen,
  onClose,
  assignIdea,
  loading,
}: AssignIdeaProps) => {
  const { t } = useTranslation();

  return (
    <Modal open={isOpen} onClose={onClose}>
      <ModalHeader>Assign {t("generic.idea")} to your account?</ModalHeader>
      <ModalContent>
        Assigning this {t("generic.idea")} to your account will allow you to
        return to it later to continue editing, as well as reply to comments.
      </ModalContent>

      <ModalActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button loading={loading} onClick={assignIdea} color="primary">
          <Icon icon={UserPlusIcon} />
          Assign
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default AssignIdea;
